export const SET_QUEUES = 'SET_QUEUES'
export const SET_CURRENT_CONFIG = 'SET_CURRENT_CONFIG'
export const NEW_CALL = 'NEW_CALL'

// USER
export const VALIDATE_TOKEN = 'VALIDATE_TOKEN'
export const SET_STORE_TYPE = 'SET_STORE_TYPE'
